export const campaignTemplatesConstants = {
    CAMPAIGN_TEMPLATES_FETCH: 'CAMPAIGN_TEMPLATES_FETCH',
    CAMPAIGN_TEMPLATES_SUCCESS: 'CAMPAIGN_TEMPLATES_SUCCESS',
    CAMPAIGN_TEMPLATES_ERROR: 'CAMPAIGN_TEMPLATES_ERROR',
};

export const TEMPLATE_CHANNEL_FILTER = {
    EMAIL: 'email',
    WHATSAPP: 'whatsapp',
};

export const EMPTY_TEMPLATE_FILTER = Object.freeze({
    channelTypes: Object.freeze([]),
    brandIds: Object.freeze([]),
});

const PUBLIC_LINK_HOST = (import.meta.env.REACT_APP_SURVEY_DOMAIN || '').replace(/\/+$/, '');
export const WA_LINK_TYPE = {
    SURVEY: 'survey',
    COUPON: 'coupon',
};

export const WA_LINK_BASES = {
    SURVEY: `${PUBLIC_LINK_HOST}/s/`,
    COUPON: `${PUBLIC_LINK_HOST}/o/`,
};

export const WA_TEMPLATE_STATUS = {
    DRAFT: 'draft',
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
    PAUSED: 'paused',
    DISABLED: 'disabled',
};

export const WA_COMPONENT_TYPE = {
    HEADER: 'HEADER',
    BODY: 'BODY',
    FOOTER: 'FOOTER',
    BUTTONS: 'BUTTONS',
};

export const WA_HEADER_FORMAT = {
    NONE: 'none',
    TEXT: 'TEXT',
    IMAGE: 'IMAGE',
};

export const WA_BUTTON_TYPE = {
    QUICK_REPLY: 'QUICK_REPLY',
    URL: 'URL',
    PHONE_NUMBER: 'PHONE_NUMBER',
};

export const WA_MAPPING_SOURCE = {
    FIELD: 'field',
    LINK_SLOT: 'link_slot',
};

export const WA_URL_SUFFIX = '{{1}}';
export const WA_URL_SUFFIX_PARAM = 'button_url';

export const WA_TEMPLATE_CATEGORIES = ['MARKETING', 'UTILITY'];

export const WA_LIMITS = {
    NAME: 512,
    HEADER: 60,
    BODY: 1024,
    FOOTER: 60,
    BUTTON_LABEL: 25,
    SAMPLE: 512,
    BUTTONS: 10,
    URL_BUTTONS: 2,
};

export const EMAIL_BLOCK_TYPE = {
    LOGO: 'logo',
    IMAGE: 'image',
    HEADING: 'heading',
    TEXT: 'text',
    BUTTON: 'button',
    DIVIDER: 'divider',
    SPACER: 'spacer',
    COLUMNS: 'columns',
    SOCIAL: 'social',
};

export const EMAIL_PALETTE_BLOCK_TYPES = [
    EMAIL_BLOCK_TYPE.LOGO,
    EMAIL_BLOCK_TYPE.IMAGE,
    EMAIL_BLOCK_TYPE.HEADING,
    EMAIL_BLOCK_TYPE.TEXT,
    EMAIL_BLOCK_TYPE.BUTTON,
    EMAIL_BLOCK_TYPE.COLUMNS,
    EMAIL_BLOCK_TYPE.DIVIDER,
    EMAIL_BLOCK_TYPE.SPACER,
];

export const EMAIL_BUTTON_BINDING = {
    URL: 'url',
    SURVEY: 'survey',
    COUPON: 'coupon',
};

export const EMAIL_SAFE_FONTS = [
    'Arial',
    'Helvetica',
    'Georgia',
    'Times New Roman',
    'Verdana',
    'Tahoma',
    'Trebuchet MS',
    'Courier New',
];

export const EMAIL_BUTTON_SHAPES = ['square', 'rounded', 'pill'];

export const EMAIL_DESIGN_SCHEMA_VERSION = 1;

export const DEFAULT_EMAIL_DESIGN_STYLES = {
    bg: '#F3F4F3',
    contentBg: '#FFFFFF',
    font: 'Arial',
    textColor: '#333333',
    buttonColor: '#1F4C5C',
    buttonShape: 'rounded',
};
